const IMPERIAL_RATIO = 0.89218269;

export function convertToImperial(value: number): number {
    return Math.round(value * IMPERIAL_RATIO);
}
